import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

const StylesProvider = styled.article`
  width: 650px;
  margin: 0 auto;
  padding: 30px;
  text-align: center;

  font-family: Montserrat, Helvetica, Arial, sans-serif;

  --color-primary: #db6d1f;

  h1 {
    color: var(--color-primary);
    font-size: 3.5em;
    margin: 0.5em 0 0;
  }
  b {
    color: slategray;
  }

  h2 {
    color: var(--color-primary);

    b {
      color: slategray;
    }
  }

  a {
    color: var(--color-primary);
    text-decoration: none;

    &:hover {
      color: #333;
      text-decoration: none;
    }
  }
`;

export const Maintenance = () => {
  const { t } = useTranslation('common');
  return (
    <StylesProvider>
      <title>{t('Site Maintenance')}</title>
      <h1>{t('Site Maintenance')}</h1>
      <img src="https://assets.hbsuk.co.uk/img/login-illustration.svg" alt={t('Virtual Lucy')} />
      <h2>We&rsquo;ll be back soon...</h2>
      <p>
        Sorry for the inconvenience but we&rsquo;re performing some planned maintenance at the moment. If you need to
        you can always <a href="mailto:support@virtuallucy.co.uk">{t('contact us')}</a>, otherwise we&rsquo;ll be back
        online shortly.
      </p>
    </StylesProvider>
  );
};
